import axios from 'src/utils/axiosNotification';
import axiosTech from 'src/utils/axios';


export const sendSubscriptionToPushServer = (userSubscription) => axios.post('/PushNotification/Subscribe', userSubscription);
export const getNotifications = (employeeId) => axiosTech.get(`/getInternalNotifications/${employeeId}`);
export const readNotifications = (employeeId,MaxId) => axiosTech.get(`/readInternalNotifications/${employeeId}/${MaxId}`);
export const notifyNotificationViewed = (id) => axios.delete(`/PushNotification/${id}`);
